import { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { IP_DATA_CO_KEY } from '../../constants/apikeys';
import qs from 'qs';
import { zips } from 'constants/zipcodes';

class DynamicData extends Component {
  static propTypes = {
    setDynamicLocation: PropTypes.func.isRequired,
    setQueryparams: PropTypes.func.isRequired,
    setUserId: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    partners: PropTypes.object,
    setPartners: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { setUserId, userId } = this.props;
    setUserId(userId);

    this.getLocation();
    this.queryParams();
  }

  getLocation = async () => {
    const result = await axios.get(
      `https://api.ipdata.co/?api-key=${IP_DATA_CO_KEY}`
    );

    this.props.setDynamicLocation(result.data);
    this.getPartners(result.data.postal);
  };

  getPartners = postal => {
    const partners = zips[postal];
    this.props.setPartners(partners);
  };

  queryParams = () => {
    const { search } = document.location;

    this.props.setQueryparams(qs.parse(search, { ignoreQueryPrefix: true }));
  };

  render() {
    return null;
  }
}

export default DynamicData;
